import Form from 'antd/es/form';
import Input from 'antd/es/input';
import Typography from 'antd/es/typography';
import React from 'react';
import { styled } from 'styled-components';

import type {
  LegalVarianceDeterminationBlockConfig,
  PipelineBlock,
} from '@mai/types';

const { TextArea } = Input;

const EditorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.marginMD}px;
`;

const EditorLabel = styled(Typography.Text)`
  font-weight: 600;
  margin-bottom: ${({ theme }) => theme.marginXXS}px;
`;

const EditorHelp = styled(Typography.Text)`
  color: ${({ theme }) => theme.colorTextSecondary};
  font-size: ${({ theme }) => theme.fontSizeSM}px;
  margin-bottom: ${({ theme }) => theme.marginXS}px;
`;

interface LegalVarianceDeterminationBlockEditorProps {
  block: PipelineBlock & { type: 'legal_variance_determination' };
  onConfigChange: (config: LegalVarianceDeterminationBlockConfig) => void;
}

export const LegalVarianceDeterminationBlockEditor: React.FC<
  LegalVarianceDeterminationBlockEditorProps
> = ({ block, onConfigChange }) => {
  const [form] = Form.useForm();

  // Initialize form with current values
  React.useEffect(() => {
    form.setFieldsValue({
      general_instructions: block.config.general_instructions || '',
    });
  }, [block.config, form]);

  const handleValuesChange = (
    _: unknown,
    allValues: Partial<LegalVarianceDeterminationBlockConfig>,
  ) => {
    onConfigChange({
      ...block.config,
      ...allValues,
    });
  };

  return (
    <EditorContainer>
      <Form
        form={form}
        layout="vertical"
        size="small"
        onValuesChange={handleValuesChange}
      >
        <Form.Item
          label={<EditorLabel>General Instructions</EditorLabel>}
          name="instructions"
          rules={[
            { required: true, message: 'Instructions are required' },
            { min: 1, message: 'Instructions cannot be empty' },
          ]}
        >
          <TextArea
            placeholder="Provide instructions for the legal variance determination LLM..."
            rows={4}
            showCount
          />
        </Form.Item>

        <EditorHelp>
          Instructions for the variance determination LLM to guide analysis of
          extracted clauses against benchmarks.
        </EditorHelp>

      </Form>
    </EditorContainer>
  );
};
